import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Shell, inputCls, btnCls } from "@/pages/Login";

export default function Signup() {
  const { signup, ref } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (ref) setCode(ref); }, [ref]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form.email, form.password, form.name, code.trim() || undefined);
      toast.success("Account created — welcome to PokeDrop!");
      nav("/drops");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <Shell title="Join PokeDrop" subtitle="Create your collector account — it's free">
      {ref && (
        <div className="mb-4 flex items-center gap-2 text-xs text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-2" data-testid="referral-banner">
          <Gift className="w-4 h-4" /> You were invited! Your friend earns an entry when you sign up.
        </div>
      )}
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="signup-name" placeholder="Display name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className={inputCls} />
        <input data-testid="signup-email" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className={inputCls} />
        <input data-testid="signup-password" type="password" placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} className={inputCls} />
        <input data-testid="signup-refcode" placeholder="Referral code (optional)" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} className={inputCls} />
        <button data-testid="signup-submit" disabled={loading} className={btnCls}>{loading ? "Creating…" : "Create account"}</button>
      </form>
      <p className="text-center text-xs text-slate-500 mt-4">
        By signing up you agree to our <Link to="/terms" className="text-gold">Terms</Link> & <Link to="/privacy" className="text-gold">Privacy Policy</Link>.
      </p>
      <p className="text-center text-sm mt-3 text-slate-400">Already have an account? <Link to="/login" className="text-gold font-semibold" data-testid="to-login">Log in</Link></p>
    </Shell>
  );
}
